var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad-wrapper ad-facility-review-top"},[_c('adsbygoogle',{attrs:{"ad-style":_vm.gadStyle,"ad-slot":"9689640881","ad-format":"fluid","ad-layout":"in-article"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }